import { ProductTypeUrlParameter } from '../models/product-type-url-parameter';
/**
 * @internal
 */
export var getProductTypeUrlParameter = function (productType) {
    if (productType === void 0) { productType = "f" /* Family */; }
    var productTypeUrlParameter;
    switch (productType) {
        case "g" /* Group */:
            productTypeUrlParameter = ProductTypeUrlParameter.Group;
            break;
        case "p" /* Product */:
            productTypeUrlParameter = ProductTypeUrlParameter.Product;
            break;
        case "f" /* Family */:
        default:
            productTypeUrlParameter = ProductTypeUrlParameter.Family;
            break;
    }
    return productTypeUrlParameter;
};
